export default "__VITE_ASSET__ou$_5mM___"